import { render, staticRenderFns } from "./TransactionFacts.vue?vue&type=template&id=30d50c6e"
import script from "./TransactionFacts.vue?vue&type=script&lang=js"
export * from "./TransactionFacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports